import { Component, EventEmitter, inject, Input, OnChanges, Optional, Output, SimpleChanges } from '@angular/core'
import { ControlContainer, NgForm, FormsModule } from '@angular/forms'
import { InputText } from 'primeng/inputtext'
import { DetailMode } from '@app/components/generic/generic.constants'

@Component({
  selector: 'app-third-party-code-field',
  templateUrl: 'third-party-code-field.component.html',
  viewProviders: [{
    provide: ControlContainer,
    deps: [[Optional, NgForm]],
    useFactory: (ngForm: NgForm) => ngForm,
  }],
  imports: [
    FormsModule,
    InputText,
  ],
})
export class ThirdPartyCodeFieldComponent implements OnChanges {
  public detailForm = inject(NgForm, { optional: true })

  @Input() thirdPartyCode?: string
  @Input() required: boolean = false
  @Input() mode: string = 'normal'
  @Input() tabindex: number = -1

  @Output() thirdPartyCodeChange = new EventEmitter<string | undefined>()

  protected readonly DetailMode = DetailMode

  ngOnChanges (changes: SimpleChanges<ThirdPartyCodeFieldComponent>) {
    if (changes.thirdPartyCode) {
      this.thirdPartyCodeChange.emit(this.thirdPartyCode)
    }
  }
}
